import React, {useState} from 'react';
import cn from 'classnames';
import SecondaryButton from '../../../ui/SecondaryButton';
import UIListBox from '../../../ui/form/UIListBox';
import {IOption} from '../../../ui/form/UIOption';

type Props = {
  options: IOption<boolean>[]
  addItem: (item: string) => void
  className?: string
  btnTitle: React.ReactNode
  btnClassName?: string
}

export default function ExternalButtonSelector({
  options, addItem, className, btnTitle, btnClassName,
}: Props) {
  const selectFirst = (allOptions: IOption<boolean>[]) =>
    (allOptions.length > 0 ? allOptions[0].value : undefined);

  const [selectedItem, setSelectedItem] = useState<string | undefined>(selectFirst(options));

  const addSelectedItem = (e: React.MouseEvent) => {
    e.preventDefault();
    if (selectedItem) {
      addItem(selectedItem);
      setSelectedItem(selectFirst(options.filter((x) => x.value !== selectedItem)));
    }
  };
  return (
    <>
      {options.length > 0 &&
      <div className={cn('flex', className)}>
        <UIListBox onChange={setSelectedItem} options={options} className="w-full"
          value={selectedItem}/>
        <SecondaryButton onClick={addSelectedItem} className={cn('ml-2', btnClassName)}
          disabled={!selectedItem} short={true}>{btnTitle}</SecondaryButton>
      </div>
      }
    </>
  );
}
